export enum RouteNames {
  // Dashboard routes
  HOME = "HOME",
  CLIENT_PAGE = "CLIENT_PAGE",
  PROJECT_PAGE = "PROJECT_PAGE",
  AI_CHAT = "AI_CHAT",
  GET_STARTED = "GET_STARTED",
  SETTINGS = "SETTINGS",

  // Connect routes
  DATA_CONNECTIONS = "DATA_CONNECTIONS",
  SUBDOMAINS = "SUBDOMAINS",
  DATA_MANAGER = "DATA_MANAGER",
  DATA_UPLOAD = "DATA_UPLOAD",

  // Train routes
  LOCATIONS = "LOCATIONS",
  CONVERSIONS = "CONVERSIONS",
  CHANNEL = "CHANNEL",
  TRAFFIC_BUCKET = "TRAFFIC_BUCKET",
  TRAFFIC = "TRAFFIC",
  TRAFFIC_CHANNELS = "TRAFFIC_CHANNELS",
  TRAFFIC_BUCKETS = "TRAFFIC_BUCKETS",
  LOCATION_PAGE = "LOCATION_PAGE",
  LEAD_SCORING_ENGAGEMENT = "LEAD_SCORING_ENGAGEMENT",
  LEAD_SCORING = "LEAD_SCORING",
  EFFECTIVENESS_PAGEVIEWS = "EFFECTIVENESS_PAGEVIEWS",
  EFFECTIVENESS_SESSIONS = "EFFECTIVENESS_SESSIONS",
  EFFECTIVENESS = "EFFECTIVENESS",
  ATTRIBUTION_SETUP = "ATTRIBUTION_SETUP",
  ALERT = "ALERT",
  ALERTS = "ALERTS",
  LEAD_STATUS = "LEAD_STATUS",
  LEAD_STATUSES = "LEAD_STATUSES",
  LOCATION_TAGS = "LOCATION_TAGS",

  // Audience routes
  TRAITS = "TRAITS",
  AUDIENCES = "AUDIENCES",
  AUDIENCE = "AUDIENCE",

  // Analyse routes
  ANALYSE = "ANALYSE",
  CUSTOM_REPORT = "CUSTOM_REPORT",
  SITE_OVERVIEW = "SITE_OVERVIEW",
  ATTRIBUTION_EXPLORER = "ATTRIBUTION_EXPLORER",
  UTM_EXPLORER = "UTM_EXPLORER",
  TRAFFIC_CAMPAIGNS = "TRAFFIC_CAMPAIGNS",
  LANDING_PAGES = "LANDING_PAGES",
  DEVICES = "DEVICES",
  TIME_AND_DAY = "TIME_AND_DAY",
  AD_TIME_AND_DAY = "AD_TIME_AND_DAY",
  ECOM_INSIGHTS = "ECOM_INSIGHTS",
  STORE_OVERVIEW = "STORE_OVERVIEW",
  STORE_PRODUCT_PERFORMANCE = "STORE_PRODUCT_PERFORMANCE",
  STORE_CUSTOMER_RETENTION = "STORE_CUSTOMER_RETENTION",
  PAID_MEDIA = "PAID_MEDIA",
  AD_PERFORMANCE_ANALYSIS = "AD_PERFORMANCE_ANALYSIS",
  ADS_OVERVIEW = "ADS_OVERVIEW",
  KEYWORDS = "KEYWORDS",
  ORGANIC = "ORGANIC",
  EMAIL_PERFORMANCE = "EMAIL_PERFORMANCE",
  ORGANIC_SOCIAL = "ORGANIC_SOCIAL",
  REFERRAL_TRAFFIC = "REFERRAL_TRAFFIC",
  GEO_EXPLORER = "GEO_EXPLORER",
  AUDIENCE_COMPARISON = "AUDIENCE_COMPARISON",
  AUDIENCE_DEEP_DIVE = "AUDIENCE_DEEP_DIVE",
  AUDIENCE_NEW_RETURNING = "AUDIENCE_NEW_RETURNING",
  AUDIENCE_USER_JOURNEY = "AUDIENCE_USER_JOURNEY",
  PRODUCTS_OVERVIEW = "PRODUCTS_OVERVIEW",
  PRODUCT_DEEP_DIVE = "PRODUCT_DEEP_DIVE",
  PRODUCT_CATEGORY_DEEP_DIVE = "PRODUCT_CATEGORY_DEEP_DIVE",
  PRODUCT_BRAND_DEEP_DIVE = "PRODUCT_BRAND_DEEP_DIVE",
  PRODUCT_PERFORMANCE_ANALYSIS = "PRODUCT_PERFORMANCE_ANALYSIS",
  PRODUCTS_PERFORMANCE_MAP = "PRODUCTS_PERFORMANCE_MAP",
  JOBS_OVERVIEW = "JOBS_OVERVIEW",
  JOBS_DEEP_DIVE = "JOBS_DEEP_DIVE",
  JOBS_CATEGORY_DEEP_DIVE = "JOBS_CATEGORY_DEEP_DIVE",
  JOBS_PERFORMANCE_MAP = "JOBS_PERFORMANCE_MAP",
  USER_DASHBOARD = "USER_DASHBOARD",
  USER_DASHBOARD_SINGLE = "USER_DASHBOARD_SINGLE",
  LOCATIONS_OVERVIEW = "LOCATIONS_OVERVIEW",
  EXIT_PAGES = "EXIT_PAGES",
  ERROR_PAGES = "ERROR_PAGES",
  CONTENT_PERFORMANCE_ANALYSIS = "CONTENT_PERFORMANCE_ANALYSIS",
  METRIC_EXPLORER = "METRIC_EXPLORER",
  DIMENSION_EXPLORER = "DIMENSION_EXPLORER",
  JOURNEY_EXPLORER = "JOURNEY_EXPLORER",
  CUSTOMER_VALUE_COHORT = "CUSTOMER_VALUE_COHORT",
  AB_TESTING_LAB = "AB_TESTING_LAB",
  SPLIT_TESTING_LAB = "SPLIT_TESTING_LAB",
  VELOCITY = "VELOCITY",
  VELOCITY_REPORT = "VELOCITY_REPORT",
  LIGHTNING_LANDING_PAGES_REPORT = "LIGHTNING_LANDING_PAGES_REPORT",
  PERSONALIZATION_REPORT = "PERSONALIZATION_REPORT",
  FUNNEL_ANALYSIS = "FUNNEL_ANALYSIS",
  CHART_LIBRARY = "CHART_LIBRARY",
  CHART_BUILDER = "CHART_BUILDER",
  CHART_TEST = "CHART_TEST",
  REPORTS = "REPORTS",
  REPORT = "REPORT",

  // Publish routes
  AB_TESTING_LAB_PUBLISH = "AB_TESTING_LAB_PUBLISH",
  PERSONALIZATION = "PERSONALIZATION",
  COMPONENTS = "COMPONENTS",
  COMPONENT = "COMPONENT",
  LIGHTNING_LANDING_TEMPLATES = "LIGHTNING_LANDING_TEMPLATES",
  LIGHTNING_LANDING_TEMPLATE = "LIGHTNING_LANDING_TEMPLATE",
  LIGHTNING_LANDING_BLOCKS = "LIGHTNING_LANDING_BLOCKS",
  LIGHTNING_LANDING_BLOCK = "LIGHTNING_LANDING_BLOCK",
  LIGHTNING_LANDING_COMPONENTS = "LIGHTNING_LANDING_COMPONENTS",
  LIGHTNING_LANDING_COMPONENT = "LIGHTNING_LANDING_COMPONENT",
  LIGHTNING_LANDING_THEME = "LIGHTNING_LANDING_THEME",
  LIGHTNING_LANDING_PAGES = "LIGHTNING_LANDING_PAGES",
  LIGHTNING_LANDING_PAGE = "LIGHTNING_LANDING_PAGE",
  SMART_LINKS = "SMART_LINKS",
  REZONATE_META_LANDING_PAGES = "REZONATE_META_LANDING_PAGES",
  SIGNALS_META_LANDING_PAGES = "SIGNALS_META_LANDING_PAGES",
  INCREMENTALITY_TESTS = "INCREMENTALITY_TESTS",
  INCREMENTALITY_SETUP = "INCREMENTALITY_SETUP",

  // Super Admin routes
  USERS = "USERS",
  SSO_TENANTS = "SSO_TENANTS",
  SUBSCRIPTIONS = "SUBSCRIPTIONS",
  CONTRACTS = "CONTRACTS",
  PRODUCTS = "PRODUCTS",
  PROJECT_SUBSCRIPTIONS = "PROJECT_SUBSCRIPTIONS",
  ANALYTICS_LABELS = "ANALYTICS_LABELS",
  AI_CREDITS = "AI_CREDITS",
  ONBOARDING = "ONBOARDING",
  NEW_PROJECT = "NEW_PROJECT",
  SHARED_COMPONENT_BLOCKS = "SHARED_COMPONENT_BLOCKS",
  SHARED_COMPONENT_BLOCK = "SHARED_COMPONENT_BLOCK",

  // Account routes
  ACCOUNT = "ACCOUNT",
  ACCOUNT_USERS = "ACCOUNT_USERS",
  ACCOUNT_USER = "ACCOUNT_USER",
  ACCOUNT_PAYMENT = "ACCOUNT_PAYMENT",
  ACCOUNT_GENERAL = "ACCOUNT_GENERAL",
  ACCOUNT_ROOT = "ACCOUNT_ROOT",
  ACCOUNT_AI = "ACCOUNT_AI",
  THANK_YOU = "THANK_YOU",
}
